<div class="table-container">

  <mat-table [dataSource]="DataGridList" class="list-container" matSort matSortDisableClear>
    @for (column of cols; track column; let i = $index) {
      <ng-container matColumnDef="{{column.field}}">
        <th mat-header-cell *matHeaderCellDef class="table-header" [style.width]="column.style.width"
          mat-sort-header>
          {{column.header | translate}}
        </th>
        <td mat-cell *matCellDef="let element; let ind = index" [style.width]="column.style.width"
          [class.alignRight]="column.alignRight" [class.alignCenter]="column.alignCenter">
          @if (column.isDate) {
            <span title="{{element[column.field]}}">{{element[column.field] |
            date:'MM/dd/yyyy'}}</span>
          }
          @if (!column.isDate && !column.isCurrency && !column.isSelect && !column.isAction) {
            <span title="{{element[column.field]}}"
            >{{element[column.field]}}</span>
          }
          @if (column.isCurrency) {
            <span title="{{element[column.field]}}"
              >{{element[column.field]? gs.OperationCurrency :''}}{{element[column.field] |
            currencyDecimalFormatter}}</span>
          }
          @if (column.isSelect) {
            <span class="removecheckboxlabel" [class.alignCenter]="column.alignCenter">
              <mat-checkbox [(ngModel)]="element.isSelected" (change)="onSelectRow($event,element)">
              </mat-checkbox>
            </span>
          }
          @if (column.isAction) {
            <span>
              <mat-icon class="mat-icon cursor-pointer" [matTooltip]="'Edit' | translate"
                matTooltipPosition="above" aria-hidden="false" aria-label="Edit" (click)="editItem(element)">
              edit</mat-icon>
              <mat-icon class="mat-icon cursor-pointer" [matTooltip]="'Delete' | translate"
                matTooltipPosition="above" aria-hidden="false" aria-label="Delete"
              (click)="removeItem(element, ind)">delete</mat-icon>
            </span>
          }
        </td>
      </ng-container>
    }

    <mat-header-row *matHeaderRowDef=" columnsToDisplay"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay; let index = index;">
    </mat-row>
  </mat-table>
  @if (DataGridList && !DataGridList.filteredData.length) {
    <div class="no-records">
    {{'Nodataavailable' | translate}}</div>
  }
  @if (DataGridList && DataGridList.filteredData.length) {
    <div class="table-total">
      {{'TotalAmountToBePayed'}} : {{gs.OperationCurrency}}
    </div>
  }
</div>